import { Box, Heading, Paragraph } from 'grommet'
import styled from 'styled-components'

export const Wrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spaces[5]}px;
  margin-top: ${({ theme }) => theme.spaces[5] + theme.spaces[4]}px;

  ${({ theme }) => theme.above.laptopL`
    max-width: 1110px;
    margin-left: auto;
    margin-right: auto;
  `}

  ${({ theme }) => theme.below.laptop`
    justify-content: center;

    & > :not(:last-child) {
      margin-bottom: ${theme.spaces[4]}px;
      margin-right: ${theme.spaces[4]}px;
    }
  `}

  ${({ theme }) => theme.below.tablet`
    align-items: center;
    justify-content: center;
    margin-top: 0;

    & > :not(:last-child) {
      margin-right: 0;
    }
  `}
`
export const Card = styled(Box)`
  max-width: 310px;
  width: 100%;

  ${({ theme }) => theme.below.tablet`
    max-width: 100%;
  `}
`

export const Title = styled(Heading)`
  ${({ theme }) => theme.getTypography('desktop', 'title', 'title3')}

  color: ${({ theme }) => theme.newColors.primary};
  margin-left: ${({ theme }) => theme.spaces[3]}px;
  text-transform: uppercase;
`

export const Subtitle = styled(Paragraph)`
  ${({ theme }) => theme.getTypography('desktop', 'body', 'body2')}

  color: ${({ theme }) => theme.newColors.darkGray};

  ${({ theme }) => theme.below.mobileL`
    ${theme.getTypography('mobile', 'body', 'body2')}
  `}
`

export const TitleWrapper = styled(Box)`
  align-items: center;
  flex-direction: row;
  margin: ${({ theme }) => theme.spaces[3]}px 0;
`
